// extracted by mini-css-extract-plugin
export default {"hero":"Register_hero__h1zBG","registerBackground":"Register_registerBackground__k7On6"};